<template>
<ul class="form-repeater">
  <template v-for="(part, pi) in value" :key="'content-'+part.key">
    <li class="add">
      <a v-for="variant in variants" href="" @click.prevent="add(pi, variant.type)" class="">+ {{ variant.name }}</a>
    </li>
    <li class="content">
      <component :is="componentForVariantType(part.type)" v-bind="propsForVariantType(part.type)" v-model="part.content" :part="part" />
      <a href="" @click.prevent="remove(pi)" class="btn btn-danger">&times;</a>
    </li>
  </template>
  <li class="add">
    <a v-for="variant in variants" href="" @click.prevent="add(value.length, variant.type)" class="">+ {{ variant.name }}</a>
  </li>
</ul>
</template>

<script>
export default {
  props: ["variants", "modelValue"],
  inheritAttrs: false,
  computed: {
    value: {
      get() {
        return this.modelValue || [];
      },
      set(value) {
        this.$emit("update:modelValue", value || []);
      },
    },
  },
  methods: {
    componentForVariantType(type) {
      for(var variant of this.variants || []) {
        if (variant.type==type)
          return variant.component;
      }
      return "div";
    },
    propsForVariantType(type) {
      var result={};
      for(var variant of this.variants || []) {
        if (variant.type==type)
          result={...(variant.props || {})};
      }
      for(var prop in this.$attrs)
        result[prop]=this.$attrs[prop];
      return result;
    },
    add(index, type) {
      this.value.splice(index, 0, {
        type: type,
        content: null,
        key: Math.random().toString().substring(2),
      });
    },
    remove(index) {
      this.value.splice(index, 1);
    },
  },
  mounted() {
    if (!this.modelValue)
      this.$emit("update:modelValue", []);
  },
}
</script>
